module.exports = __webpack_public_path__ + "img/Walnussstrasse.52c77857.svg";